/**
 * Front-end script for the piano block.
 * Handles note playback (click, touch, keyboard), label visibility toggles,
 * and orientation guidance for mobile users.
 */
import {__} from "@wordpress/i18n";

document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll('.wp-block-superprof-piano-block').forEach(piano => {

		// Show a landscape orientation hint on mobile devices
		const orientationMessage = document.createElement('div');
		orientationMessage.className = 'orientation-message';
		orientationMessage.innerText = __('Pour une meilleure expérience, basculez votre appareil en mode paysage.', "superprof-gutenberg-blocks");
		piano.querySelector('.piano').prepend(orientationMessage);

		// Inject the toggle buttons for showing/hiding note names and keyboard shortcuts
		const toggleBtn = piano.parentElement.querySelector('.toggle-labels');
		if (toggleBtn) {
			toggleBtn.innerHTML = `
					<button class="show-note">${__("Afficher le nom des notes", "superprof-gutenberg-blocks")}</button>
					<button class="show-key">${__("Afficher les touches du clavier", "superprof-gutenberg-blocks")}</button>
				`;
		}

		if (toggleBtn) {
			const showNoteBtn = toggleBtn.querySelector('.show-note');
			const showKeyBtn = toggleBtn.querySelector('.show-key');
			showNoteBtn.addEventListener('click', () => {
				showNoteBtn.classList.toggle('active');
				if (showNoteBtn.classList.contains('active')) {
					showNoteBtn.textContent = __("Masquer le nom des notes", "superprof-gutenberg-blocks");
				} else {
					showNoteBtn.textContent = __("Afficher le nom des notes", "superprof-gutenberg-blocks");
				}
				piano.querySelectorAll('.note-label .note').forEach(label => {
					label.classList.toggle('hidden');
				});
			});
			showKeyBtn.addEventListener('click', () => {
				showKeyBtn.classList.toggle('active');
				if (showKeyBtn.classList.contains('active')) {
					showKeyBtn.textContent = __("Masquer les touches du clavier", "superprof-gutenberg-blocks");
				} else {
					showKeyBtn.textContent = __("Afficher les touches du clavier", "superprof-gutenberg-blocks");
				}
				piano.querySelectorAll('.note-label .keyboard').forEach(label => {
					label.classList.toggle('hidden');
				});
			});
		}

		/**
		 * Plays a silent audio clip to unlock the Web Audio context on iOS,
		 * which requires a user gesture before any audio can be played.
		 */
		function unlockAudio() {
			const audio = new Audio('data:audio/wav;base64,UklGRigAAABXQVZFZm10IBAAAAABAAEAIlYAAESsAAACABAAZGF0YQAAAAA=');
			audio.play().catch(() => {});
		}

		const keys = piano.querySelectorAll('.piano [data-note]');
		// Set of currently touched note identifiers, used to avoid replaying the same note
		// during a single touch gesture (touchmove can fire many times over the same key).
		const touchedKeys = new Set();

		/**
		 * Plays the audio file for the given note and briefly highlights the key.
		 * @param {string} note - The note identifier (e.g. '1c', '3fis') matching an audio filename.
		 */
		function playNote(note) {
			const audio = new Audio(`/blog/wp-content/plugins/superprof-gutenberg-blocks/audio/${note}.mp3`);
			audio.play();

			// Add an 'active' class for visual feedback, then remove it after 150ms
			const keyEl = piano.querySelector(`[data-note="${note}"]`);
			if (keyEl) {
				keyEl.classList.add('active');
				setTimeout(() => keyEl.classList.remove('active'), 150);
			}
		}

		// Attach click and touchstart listeners to each key
		keys.forEach(key => {
			// Mouse click: play the note directly
			key.addEventListener('click', () => {
				const note = key.getAttribute('data-note');
				playNote(note);
			});

			// Touch start: unlock audio context (iOS) then play the touched note
			key.addEventListener('touchstart', (e) => {
				unlockAudio();
				const touch = e.changedTouches[0];
				const touchedElement = document.elementFromPoint(touch.clientX, touch.clientY);
				if (touchedElement && touchedElement.hasAttribute('data-note')) {
					const note = touchedElement.getAttribute('data-note');
					// Only play if this note hasn't already been triggered in this gesture
					if (!touchedKeys.has(note)) {
						touchedKeys.add(note);
						playNote(note);
					}
				}
			}, { passive: true });
		});

		// Touch move: allows sliding across keys to play multiple notes in one gesture
		piano.addEventListener('touchmove', (e) => {
			for (let i = 0; i < e.touches.length; i++) {
				const touch = e.touches[i];
				const el = document.elementFromPoint(touch.clientX, touch.clientY);

				if (el && el.hasAttribute('data-note')) {
					const note = el.getAttribute('data-note');
					// Guard: only play each note once per gesture
					if (!touchedKeys.has(note)) {
						touchedKeys.add(note);
						playNote(note);
					}
				}
			}
		}, { passive: true });

		// Touch end: clear the touched keys set to allow replaying the same notes next gesture
		piano.addEventListener('touchend', () => {
			touchedKeys.clear();
		});

		// Keyboard support: map pressed keys to piano notes via data-keyboard attributes
		document.addEventListener('keydown', (e) => {
			// Ignore browser/OS shortcuts (e.g. Ctrl+Shift+I for DevTools)
			if (e.ctrlKey && e.shiftKey) {
				return;
			}

			const pressedKey = e.key.toLowerCase();
			// CSS.escape handles special characters (e.g. '<', ':', ',') in attribute selectors
			const escapedKey = CSS.escape(pressedKey);

			const keyEl = piano.querySelector(`[data-keyboard="${escapedKey}"]`);
			if (keyEl) {
				const note = keyEl.getAttribute('data-note');
				playNote(note);
			}
		});
	});
});
